<template lang="pug" src="./remove-dialog.pug"> </template>
<style lang="scss" src="./remove-dialog.scss" scoped> </style>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        removeReasonId: {
            type: Number,
            default: null
        }
    },
    computed: {
        removeDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        removeRequestReason() {
            this.$emit('onRemoveReason', this.removeReasonId);
            this.closeRemoveDialog();
        },

        closeRemoveDialog() {
            this.removeDialog = false;
        }
    }
};
</script>
